<template>
    <div>
        <Loader ref="Loader"></Loader>
        <ErrorModal ref="ErrorModal"></ErrorModal>
        <SuccessModal ref="SuccessModal"></SuccessModal>
        <YesNoModal ref="YesNoModal"></YesNoModal>
        <Allocation ref="Allocation" :customerItems="customerItems" @allocated="allocationsUpdated"></Allocation>
        <CopyMonth ref="CopyMonth" @duplicate="duplicate"></CopyMonth>

        <v-layout justify-center wrap>
            <v-flex md12>
                <v-toolbar dense color="secondary" dark>
                    <v-toolbar-title>Ops-Manager Allocation</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-text-field append-icon="search" v-model="search"
                        placeholder="Search ops-manager allocations"></v-text-field>
                </v-toolbar>

                <!-- Filters -->
                <div>
                    <v-layout justify-start row>
                        <v-flex xs2 mx-2>
                            <v-combobox label="Select customer" v-model="filterModel.CustomerID" :items="customerItems"
                                item-text="Name" item-value="ID" @change="GetCustomerVenues()" clearable></v-combobox>
                        </v-flex>
                        <v-flex xs2 mx-2>
                            <v-combobox label="Select venue" v-model="filterModel.CustomerVenueID" :items="venueItems"
                                item-text="Name" item-value="ID" :disabled="venueItems.length == 0" clearable>
                            </v-combobox>
                        </v-flex>
                        <v-flex xs2 mx-2>
                            <v-combobox v-model="filterModel.SystemUserID" label="Select ops-manager"
                                :items="systemUserItems" :item-text="text" item-value="ID" clearable>
                            </v-combobox>
                        </v-flex>
                        <v-flex xs2 mx-2>
                            <v-select :items="availableMonths" small label="Current Month" size="small"
                                v-model="currentMonth"></v-select>
                        </v-flex>

                        <v-flex>
                            <v-btn fab outline small color="primary" @click="prev">
                                Prev
                            </v-btn>
                            <v-btn fab outline small color="primary" @click="next">
                                Next
                            </v-btn>
                            <v-btn outline small color="primary" @click="showCopy">
                                Duplicate Month
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </div>

                <!-- Calendar -->
                <div style="height:calc(100vh - 200px);">
                    <v-calendar ref="calendar" type="month" @change="GetAllocations" @click:date="viewDay"
                        v-model="start" :end="end">
                        <template v-slot:day="{ date }">
                            <template v-for="event in eventsMap[date]">
                                <div style="width:100%; color:white; background-color: #d9241b; padding:1px 2px 1px 2px; border-radius: 2px; margin-bottom: 1px;"
                                    :style="{ 'background-color': event.color }">
                                    <div style="display:flex; justify-content: space-between;">
                                        <div style="font-size:10px; font-weight: bold;">{{ event.username }}</div>
                                        <div v-if="!event.Complete">
                                            <button style="padding: 2px; background-color:red; font-size:10px;"
                                                @click="() => deleteItem(event)">Delete</button>
                                        </div>
                                    </div>
                                    <div style="font-size:12px;">{{ event.name }}</div>
                                </div>
                            </template>
                        </template>
                    </v-calendar>
                </div>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import JWT from "jsonwebtoken";
import Allocation from "./allocation.vue"
import CopyMonth from "./copy-month.vue"
import moment from 'moment'

export default {
    components: {
        Allocation,
        CopyMonth
    },
    data() {
        let self = this;
        var date = new Date();
        return {
            CustomerList: [{
                ID: -1,
                Name: 'All'
            }],
            SelectedCustomer: null,
            SelectedSysUser: null,
            SysUserList: [],
            editing: false,
            editingID: 0,
            valid: false,
            actionItems: [{
                type: "edit",
                title: "Modify",
                access: self.HasAccess("OPS_MANAGER_ALLOCATION_MANAGEMENT", "MODIFY"),
                icon: "edit"
            },
            {
                type: "delete",
                title: "Delete",
                access: self.HasAccess("OPS_MANAGER_ALLOCATION_MANAGEMENT", "DELETE"),
                icon: "delete"
            }
            ],
            items: [],
            customerItems: [],
            venueItems: [],
            systemUserItems: [],
            classTypeItems: [],
            filterModel: {
                CustomerID: null,
                CustomerVenueID: null,
                SystemUserID: null,
                AllocatedDate: null
            },
            userID: 0,
            role: 0,
            search: null,
            start: new Date(date.getFullYear(), date.getMonth(), 1),
            end: new Date(date.getFullYear(), date.getMonth() + 1, 0),
            currentMonth: parseInt(moment(new Date(date.getFullYear(), date.getMonth(), 1)).format(`M`)),
            colors: ['blue', 'indigo', 'cyan', 'green', 'orange', 'grey'],
            availableMonths: [{
                text: 'January',
                value: 1
            }, {
                text: 'February',
                value: 2
            }, {
                text: 'March',
                value: 3
            }, {
                text: 'April',
                value: 4
            }, {
                text: 'May',
                value: 5
            }, {
                text: 'June',
                value: 6
            }, {
                text: 'July',
                value: 7
            }, {
                text: 'August',
                value: 8
            }, {
                text: 'September',
                value: 9
            }, {
                text: 'October',
                value: 10
            }, {
                text: 'November',
                value: 11
            }, {
                text: 'December',
                value: 12
            }]
        }
    },
    mounted() {
        let self = this;

        self.userID = localStorage.getItem("USER_ID");
        self.role = localStorage.getItem("Role");

        //self.GetAllocations();
        self.GetCustomers();
        self.FetchOpsManagers();
        self.GetSystemUsers();

        self.currentMonth = parseInt(moment(self.start).format(`M`))
        console.log(moment(self.start).format(`M`))

        this.$refs.calendar.checkChange()
    },
    watch: {
        currentMonth(oldVal, newVal) {
            var diff = oldVal - newVal;
            console.log(oldVal, newVal, diff);

            this.$refs.calendar.move(diff);
            this.$refs.calendar.checkChange()
        }
    },
    computed: {
        // convert the list of events into a map of lists keyed by date
        eventsMap() {
            const map = {};
            let filteredItems = this.items;

            if (this.filterModel.CustomerID != null)
                filteredItems = this.items.filter(el => el.Customer.ID == this.filterModel.CustomerID.ID);

            if (this.filterModel.CustomerVenueID != null)
                filteredItems = filteredItems.filter(el => el.CustomerVenue.ID == this.filterModel.CustomerVenueID.ID);

            if (this.filterModel.SystemUserID != null) {
                filteredItems = filteredItems.filter(el => el.SystemUser.ID == this.filterModel.SystemUserID.ID);
            }

            console.log(filteredItems, this.items, this.filterModel)

            filteredItems.forEach(e => (map[e.date] = map[e.date] || []).push(e))

            return map
        }
    },
    methods: {
        text: item => item.Title + ' ' + item.FirstName + ' ' + item.LastName,
        FetchOpsManagers() {
            let self = this;

            self.get(`SystemUser/GetOpsManagers`).then(r => {
                self.SysUserList = r.data;
            })
        },
        GetAllocationsBySysUser() {
            let self = this;

            self.$nextTick(() => {
                self.get(`OpsManagerTaskGroup/GetByOpsManager?opsmanagerID=${self.SelectedSysUser.ID}`).then(r => {
                    self.items = r.data;
                })
            })
        },
        ClearFilter() {
            let self = this;

            self.items = [];

            self.SelectedCustomer = null;
            self.SelectedSysUser = null;
        },
        GetSystemUsers() {
            let self = this;
            self.get(`SystemUser/GetOpsManagers`).then(
                r => {
                    console.log("OPS MANAGERS", r.data)
                    self.systemUserItems = r.data;
                })
        },
        GetCustomers() {
            let self = this;
            let url;

            switch (self.role.toUpperCase()) {
                case "MASTER": {
                    url = `Customer`;
                    console.log("url = master")
                }
                    break;
                case "ADMIN": {
                    url = `Customer`;
                    console.log("url = admin")
                }
                    break;
                default: {
                    url = `Customer/GetBySystemUser?systemUserID=${self.userID}`;
                    console.log("url = default")
                }
                    break;
            }

            self.get(url)
                .then(response => {
                    self.customerItems = response.data;

                    response.data.forEach(customer => {
                        self.CustomerList.push(customer);
                    })
                })
                .catch(error => {
                    self.$refs.ErrorModal.show();
                    self.$refs.ErrorModal.setText(error.toString());
                });
        },
        GetCustomerVenues() {
            let self = this;

            self.$nextTick(() => {
                console.log("SELECTED CUSTOMER", self.filterModel.CustomerID);
                var customerID = self.filterModel.CustomerID.ID;
                self.get(`CustomerVenue/CustomerID?customerID=${customerID}`).then(
                    r => {
                        self.venueItems = r.data;
                    })

            })
        },
        GetCustomerAllocations() {
            let self = this;

            self.$refs.Loader.show(true);
            self.$refs.Loader.setText("Loading...");

            self.$nextTick(() => {
                self.get(`OpsmanagerTaskGroup/GetAllByCustomer?customerID=${self.SelectedCustomer.ID}`)
                    .then(r => {
                        self.$refs.Loader.hide();
                        self.items = r.data;
                    })
            })
        },
        GetAllocations({ start, end }) {
            let self = this;
            self.$refs.Loader.show(true);
            self.$refs.Loader.setText("Loading...");

            self.get(`OpsManagerAssessmentAllocation/GetAllocations?start=${start.date}&end=${end.date}`).then(r => {
                self.$refs.Loader.hide();
                self.items = r.data.map(item => {
                    var dtSplit = item.AllocatedDate.split("T");
                    var color = "#eb7a34"

                    if (item.CheckedIn) {
                        color = "#3496eb"
                    }

                    if (item.Complete) {
                        color = "#39753f"
                    }

                    return {
                        name: `${item.Customer.Name}, ${item.CustomerVenue.Name}`,
                        username: ` ${item.SystemUser.FirstName[0]}. ${item.SystemUser.LastName}`,
                        date: dtSplit[0],
                        time: dtSplit[1],
                        color: color,
                        timed: false,
                        ID: item.ID,
                        CheckedIn: item.CheckedIn,
                        CheckedOut: item.CheckedOut,
                        Complete: item.Complete,
                        Customer: item.Customer,
                        SystemUser: item.SystemUser,
                        CustomerVenue: item.CustomerVenue
                    }
                });

                self.GetCustomers();
            })
        },
        SubmitAllocation() {
            let self = this;

            let Request = {
                ClassTypeID: self.AllocationForm.ClassTypeID.ID,
                CustomerID: self.AllocationForm.CustomerID.ID,
                CustomerVenueID: self.AllocationForm.CustomerVenueID.ID,
                SystemUserID: self.AllocationForm.SystemUserID.ID,
            }
            console.log("REQUEST", Request)
            self.post(`OpsManagerTaskGroup/Exists`, Request).then(result => {
                if (result.data == false) {
                    self.post(`OpsManagerTaskGroup`, Request).then(r => {
                        self.$refs.SuccessModal.show(); // success modal
                        self.$refs.SuccessModal.setText("Ops Manager has been allocated!");
                        setTimeout(function () {
                            //self.GetAllocations();
                            self.$refs.form.reset();
                            self.$refs.SuccessModal.hide();
                        }, 1000);
                    })
                } else {
                    self.$refs.ErrorModal.show();
                    self.$refs.ErrorModal.setText(
                        "This allocation already exists."
                    );
                }
            })
        },
        PerformOperation(action, item) {
            let self = this;
            switch (action.type.toUpperCase()) {
                case "DELETE": {
                    self.deleteItem(item);
                }
                    break;
                case "EDIT": {
                    self.editing = true;
                    self.editingID = item.ID;
                }
                    break;
            }
        },
        editItem(item) {
            let self = this;

            console.log("EDIT ITEM", item);
            self.put(`OpsManagerTaskGroup?id=${item.ID}`, item).then(r => {
                self.$refs.SuccessModal.show(); // success modal
                self.$refs.SuccessModal.setText("Ops Manager class type has been edited!");
                setTimeout(function () {
                    //self.GetAllocations();
                    self.editing = false;
                    self.editingID = 0;
                    self.$refs.SuccessModal.hide();
                }, 1000);
            })

        },
        deleteItem(item) {
            let self = this;
            self.$refs.YesNoModal.show(
                "Are you sure you want to delete this ops-manager allocation?",
                function (yes) {
                    if (yes == true) {
                        self.$refs.Loader.show(true);
                        self.$refs.Loader.setText("Deleting allocation...");
                        self
                            .delete(`OpsManagerAssessmentAllocation/RemoveAllocation?id=${item.ID}`)
                            .then(result => {
                                self.$refs.Loader.hide();
                                if (result.data == true) {
                                    var index = self.items.indexOf(item);
                                    if (index > -1) {
                                        self.items.splice(index, 1);
                                    }
                                }
                            })
                            .catch(error => {
                                self.$refs.Loader.hide();
                                self.$refs.ErrorModal.show();
                                self.$refs.ErrorModal.setText(error.toString());
                            });
                    }
                }
            );
        },
        viewDay(day) {
            this.$refs.Allocation.show(day);
        },
        showEvent() { },
        allocationsUpdated(item) {
            var dtSplit = item.AllocatedDate.split("T");

            this.items.push({
                name: `${item.Customer.Name}, ${item.CustomerVenue.Name}`,
                username: ` ${item.SystemUser.FirstName[0]}. ${item.SystemUser.LastName}`,
                date: dtSplit[0],
                time: dtSplit[1],
                color: "#eb7a34",
                timed: false,
                ID: item.ID,
                CheckedIn: item.CheckedIn,
                CheckedOut: item.CheckedOut,
                Complete: item.Complete,
                Customer: item.Customer,
                SystemUser: item.SystemUser,
                CustomerVenue: item.CustomerVenue
            });
        },
        rnd(a, b) {
            return Math.floor((b - a + 1) * Math.random()) + a
        },
        next() {
            let self = this;
            this.$refs.calendar.next();

            this.$nextTick(() => {
                self.currentMonth = parseInt(moment(self.start).format(`M`))
            })
        },
        prev() {
            let self = this;
            this.$refs.calendar.prev();

            this.$nextTick(() => {
                self.currentMonth = parseInt(moment(self.start).format(`M`))
            })
        },
        showCopy() {
            this.$refs.CopyMonth.show(this.currentMonth);
        },
        duplicate(data) {
            let self = this;

            self.$refs.Loader.show(true);
            self.$refs.Loader.setText("Duplicating, please wait...");

            self.post(`OpsManagerAssessmentAllocation/Duplicate?fromMonth=${data.from}&toMonth=${data.to}`).then(
                r => {
                    if (r.data) {
                        self.$refs.Loader.hide();

                        self.$refs.SuccessModal.show(); // success modal
                        self.$refs.SuccessModal.setText("Allocations have been duplicated!");
                        setTimeout(function () {
                            self.$refs.SuccessModal.hide();
                        }, 1000);
                    }
                })
        }
    }
}
</script>

<style></style>